import React from "react";
import LoaderIcon from 'react-loader-icon';
import "./loading.css";

export default props => {
    return (
        <div className="loadingPage">
            <div className="loadingIcon">
                <h1>Trackadillo</h1>
                <LoaderIcon type={"cubes"} color={"white"}/>
            </div>
        </div>
    )
}